import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, interval, switchMap, map } from 'rxjs';
import { lessonSlide } from 'app/models/lessonSlide.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';
import { postSse, type SseEvent } from '../utils/sse-post';


@Injectable({
  providedIn: 'root'
})
export class lessonSlideService {


  private baseUrl = `${environment.baseUrl}/lessonMgmt`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }



  getLessonSlide(userid: number, lessonId: number, slideId: string, slideTitle: string): Observable<any> {
    // debugger;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "slideId": slideId,
        "slideTitle": slideTitle,
        "tenant": null
      }
    };

    // let aaa = this.http.post(`${this.baseUrl}/getLessonSlide`, body, { headers });
    // console.log('getLessonSlide response:', aaa);
    // return aaa;

    let aaa = this.commonAPI.postApiCall(`${this.baseUrl}/getLessonSlide`, body);
    console.log('getLessonSlide response:', aaa);
    return aaa;

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }

  /** SSE: progress while slide is loaded or AI-generated (event `complete` has `slide`). */
  streamGetLessonSlide(
    userid: number,
    lessonId: number,
    slideId: string,
    slideTitle: string,
    onEvent: (ev: SseEvent) => void,
    opts?: { allowMissingSourcePageRef?: boolean },
  ): Promise<void> {
    return postSse(
      '/lessonMgmt/getLessonSlideStream',
      {
        userId: userid,
        lessonId,
        slideId,
        slideTitle,
        allowMissingSourcePageRef: opts?.allowMissingSourcePageRef === true,
      },
      onEvent,
      { timeoutMs: 0 }
    );
  }


  saveLessonSlide(userid: number, lessonId: number, slideId: string, updatedSlide: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "slideId": slideId,
        "updatedSlide": updatedSlide,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/saveLessonSlide`, body);

    // return this.http.post(`${this.baseUrl}/saveLessonSlide`, body, { headers });

  }

  getSlidePreview(userid: number, lessonId: number, slideId: string): Observable<any> {
    const body = {
      criteria: {
        userId: userid,
        lessonId,
        slideId,
        tenant: null
      }
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/getSlidePreview`, body);
  }



  generateSlide(userid: number, lessonId: number, slideId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "slideId": slideId,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/getLessonSlide`, body);
    // return this.http.post(`${this.baseUrl}/getLessonSlide`, body, { headers });
  }


  eraseAndGenerateSlide(userid: number, lessonId: number, slideId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "slideId": slideId,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/eraseandGenerateLessonSlide`, body);

    // return this.http.post(`${this.baseUrl}/eraseandGenerateLessonSlide`, body, { headers });
  }

  /**
   * Regenerate one IMAGE element via AI. Prompt: criteria.prompt, else imagePrompt/notes on the server.
   */
  regenerateSlideImage(
    userId: number,
    lessonId: number,
    slideId: string,
    opts?: { elementId?: string; prompt?: string },
  ): Observable<any> {
    const body = {
      criteria: {
        userId,
        lessonId,
        slideId,
        elementId: opts?.elementId,
        prompt: opts?.prompt,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/regenerateSlideImage`, body);
  }

}

